import { render } from "./TicketExportTemplate.vue?vue&type=template&id=4dbdc614"
import script from "./TicketExportTemplate.vue?vue&type=script&lang=js"
export * from "./TicketExportTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__